module.exports = __webpack_public_path__ + "static/media/arrow-bottom.71e0bf04.svg";